import { EmbeddedBrightcovePlayer } from './brightcove-player';

// The isolated embed page (video_player_embed.html) does not extend base.html, so the
// analytics globals the player expects — window.vumedi (mixpanel), gtag, and
// window.eventTracker — are never defined. The player calls these unconditionally in hot
// paths like _seekVideo(), so a missing global throws and aborts the handler before the
// action runs (e.g. seek buttons become silent no-ops). Install no-op stubs so the embed,
// which intentionally does no tracking, runs those paths safely. Only fill in what's absent.
function installAnalyticsStubs() {
    window.vumedi = window.vumedi || {};
    window.gtag = window.gtag || function () {};
    // eventTracker methods are called directly (no optional chaining), so back it with a
    // proxy that returns a no-op for any method name the player invokes.
    window.eventTracker = window.eventTracker || new Proxy({}, { get: () => () => {} });
}

document.addEventListener('DOMContentLoaded', () => {
    const context = window.__VUMEDI_VIDEO_DETAIL_CONTEXT__;

    installAnalyticsStubs();

    new EmbeddedBrightcovePlayer().initialize(
        document.getElementById(context.playerTagId),
        context.brightcoveId,
        context.accountId,
        context.playerId,
    );
});
